declare const I18n: any;

import React from "react";

type RankBadgeProps = {
  level: number;
  slug: string;
  unlocked: boolean;
};

const RankBadge: React.FC<RankBadgeProps> = ({ level, slug, unlocked }) => {
  const iconPath = `/level_${level}_icon.svg`;

  return (
    <div
      className={`rank-badge rank-badge--${level} ${unlocked ? "rank-badge--unlocked" : "rank-badge--locked"
        } d-flex flex-row align-items-center`}
    >  <div className="rank-badge__inner">
        <img
          src={iconPath}
          alt={`Level ${level} icon`}
          width={70}
          height={70}
          className="rank-badge__icon"
        />

        <div className="text-left">
          <div className="fw-bold">{I18n.t("models.overall_rank.messaging.level", { level: level })}</div>
          <div>{I18n.t(`models.overall_rank.attributes.${slug}`)}</div>
        </div>
      </div>
    </div>
  );
}

export default RankBadge;